module.exports = __webpack_public_path__ + "static/media/source-sans-pro-semibolditalic.58153ac7.eot";